import React, { useState } from 'react';
import { useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function LineChart(props) {
  const { title, categories, series, tooltip } = props;

  const mySeries = series || [
    {
      name: 'Session Duration',
      data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
    },
    {
      name: 'Page Views',
      data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
    }
  ];

  const [options, setOptions] = useState({
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [3, 3],
      curve: 'straight',
      dashArray: [0, 0]
    },
    title: {
      text: title || 'Product Trends by Month',
      align: 'left'
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
      }
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5
      }
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6
      }
    },
    xaxis: {
      categories: categories
    },
    tooltip: tooltip || {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + ' (mins)';
            }
          }
        },
        {
          title: {
            formatter: function (val) {
              return val;
            }
          }
        }
      ]
    },
    grid: {
      borderColor: '#f1f1f1'
    }
  });

  useEffect(() => {
    setOptions({
      ...options,
      xaxis: {
        categories: categories
      }
    });
  }, [categories]);

  return (
    <div id="chart">
      <ReactApexChart options={options} series={mySeries} type="line" height={280} />
    </div>
  );
}
